import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        7000419: 'Yes',
        7000414: 'No',
        pageWelcomeTitle: 'Home',
        aircraft: 'Aircrafts',
        light: 'Light',
        dark: 'Dark',
        entries_per_page: 'Entries per page',
        sso_connect: 'Connecting to SSO...',
        sso_login_fail: 'The SSO connexion failed. Please enter your credentials manually!',
        saveUserPreferences: 'Save preferences',
        updateSuccessful: 'The update has been successfully performed',
        '3C00002': 'Deletion performed',
        sessionExpired: 'Session has expired!',
        SSO_LOGIN_FAIL: 'The SSO (Single Sign-On) connection has failed!',
        modal_messages_no_message: 'No message to display!',
        modal_search_pn: 'PN search',
        modal_search_sn: 'Equipment search',
        modal_search_staff: 'Personnel search',
        modal_search_qualification: 'Qualification search',
        pagination_first: 'first',
        pagination_previous: 'previous',
        pagination_next: 'next',
        pagination_last: 'last',
        7000014: 'In progress',
        7001655: 'Search',
        expand_all: 'Expand all',
        collapse_all: 'Collapse all',
        7000398: 'Change',
        execute: 'Execute',
        work_completed: 'Work completed',
        work_not_completed: 'Work not completed',
        modal_required_tools: 'Copy required tools',
        copy_tools: 'Copy {{pn}}',
        7003804: 'Non-performance code',
        7003805: 'Reason for non-performance',
        tracking: 'Tracking',
        input_compulsory_fields_missing: 'Please feed in all compulsory fields so that you can proceed further.',
        input_fields_in_error: 'Some data is incomplete or erroneous.',
        disable_resource_copy:
          'You cannot copy this resource because it is already present in the resources being used.',
        copy_used_resources: 'Copy used resources',
        required_sn_field: 'SN field is required',
        labor_added: 'A labor entry will be added',
        7000318: 'Add',
        9500050: 'Display Fleet',
        9500006: 'FR',
        9500007: 'EN',
        9500008: 'Open user profile',
        8000395: 'Disconnection',
        8000144: 'Settings',
        8000569: 'Cancel',
        8000202: 'Validate',
        9500174: 'Submit',
        9510089: 'Are you sure, you want to permanently delete this item?',
        9510090: 'Are you sure, you want to permanently delete all selected items?',
        7003518: 'Hours scanning',
        'GEN0090': 'Changes in progress will be lost, do you really want to leave this screen ?',
        '3C00007': 'Changes in progress will be lost, do you really want to leave edit mode ?',
        7000483: 'User',
        7000244: 'Password',
        9510043: 'Token',
        9510046: 'The MFA authentication failed',
        9510047: 'An authentication problem occurred. Please refresh the page!',
        9480012: 'Forgotten password',
        9500010: 'Add widgets',
        7001712: 'Planning',
        7000155: 'Registration',
        9500011: 'Progression by Man hour & Items',
        workpackage_stats: 'Man hour & Items statistics',
        9500012: 'Progression by task type',
        workpackage_task_detail: 'Details by task type',
        9500013: 'Increase the width',
        9500014: 'Decrease the width',
        9500015: 'Increase the height',
        9500016: 'Decrease the height',
        9500017: 'Workload by kind of task',
        9500018: 'File status',
        9500019: 'List of selected tasks',
        9500020: 'WO Description',
        7000993: 'Legend',
        9500021: 'Performed',
        9500022: 'To be performed',
        9500023: 'Man hour',
        9500024: 'Items',
        9500025: 'WO No',
        9500026: 'Status',
        9500027: 'MEL code',
        '1MOE048': 'MEL item',
        9500028: 'Opening date',
        9500029: 'Deadline',
        9500030: 'Requested job or anomalies',
        9500031: 'A/C',
        9500032: 'Station',
        9500033: 'Last TL',
        9500034: 'Date',
        7000374: 'Time',
        9500035: 'Situation',
        9500036: 'Configuration',
        9500037: 'HIL',
        9500038: 'MRP',
        9500039: 'WO',
        9500040: 'Opened WP',
        9500041: 'Task type',
        9500042: 'Reference',
        9500043: 'Status',
        9500044: 'Follow-up type',
        9500045: 'Remaining potential',
        9500046: 'Deadline',
        9500047: 'PN',
        9500048: 'SN',
        9500049: 'Requested job or anomalies',
        9500051: 'List of A/C to be submitted',
        9500052: 'Report',
        9500053: 'Mean Remaining Potential (MRP)',
        9500054: 'Work Order (WO)',
        9500055: 'No data to display.',
        '0LMA106': 'Total',
        9500077: 'Page',
        9500078: 'This widget can not be removed since it is part of the widgets required fot his page!',
        9500079: 'This widget is optional and may be removed by clicking on this button.',
        9500081: 'Item label',
        '1M00023': 'Subtype',
        9500092: 'Workpackage Status',
        9500095: 'Tasks without M/h',
        9500096: 'Deferred',
        9500097: 'Ops',
        9500119: 'CHK Ops',
        9500098: 'OOP Ops',
        9500099: 'WO',
        9500100: 'WO (TL)',
        9500101: 'WO (MC)',
        9500102: 'WO (DOC)',
        9500103: 'WO (KX)',
        9500104: 'WO (MIS)',
        9500105: 'Additional WO',
        9500106: 'No data available.',
        9500107: 'Check progress(from the beginning until today)',
        9500108: 'Parking',
        7003777: 'Hangar',
        9500109: 'Aggregated data',
        9500110: 'OP (All kinds)',
        7003008: 'Tasks',
        9500117: 'To be performed',
        9400199: 'Performed',
        9500111: 'Deferred',
        9100848: 'With AW',
        9500118: 'Nb. of AW',
        9500112: 'Additional works',
        7000841: 'It',
        9500115: 'Items Type',
        OLD8034: 'This area must be completed',
        '1LEX071': 'Document',
        9200107: 'DF/AW',
        '0P00003': 'Title',
        '0EKS004': 'ATA',
        7000494: 'Zone',
        '1MOE023': 'Performance date',
        '1P00399': 'Deferral/AW',
        '0MRM071': 'WO No',
        9500116:
          'This widget can not be removed since it is a dependency of another widget. In order to remove it, please remove its parent widget instead!',
        9420008: 'Validation Normal Order',
        '1P00012': 'Type',
        9500121: 'Order no',
        7000480: 'Priority',
        7000588: 'Deadline',
        7000892: 'Responsible',
        7001518: 'Validator',
        7001950: 'Supplier',
        7001202: 'Total EOT',
        9500122: 'Current level',
        9500123: 'Required level',
        9500124: 'Order to validate',
        9500132: 'You are now logged in to the application.',
        9500133: 'You are now disconnected from the application.',
        9500134: 'Clear all messages',
        9220626: 'Deny',
        9500136: 'Sign',
        9500137: 'Finalize',
        9500138: 'You do not have enough permissions to access this functionality.',
        9500139: 'Please choose the next validator',
        9500144: 'Work Order',
        7001905: 'No',
        9500143: 'Bound check',
        9400064: 'Opening date',
        '1MOE031': 'Issuer',
        8000442: 'Work station',
        '1P08215': 'Phase',
        7000914: 'Qualification',
        '2MOE097': 'Requested work',
        '2MOE098': 'Performed work',
        9100439: 'by',
        9501005: 'You do not have enough permissions to view this order.',
        9500148: 'Please configure the next validators into AMASIS.',
        9500149: 'This order has already been validated with the same level of validation.',
        9500150:
          'You can not validate this order since its required validation level is greater than your own validation level.',
        9500145: 'Order refusal {0}',
        9500151: 'Please provide grounds for the refusal',
        9500152: 'Order validation {0}',
        9500153: 'This order requires further validation.',
        9500155: 'Please select the next validator',
        9500156: 'You are only allowed to view this order!',
        9500157: 'Display with tolerances',
        7001825: 'List TLs',
        '0MOE065': 'TL No',
        7002927: 'Flight No',
        9420175: 'Departure Airport',
        9420176: 'Arrival Airport',
        9500158: 'Flight Duration (A/B)',
        9500185: 'Flight Duration (B/B)',
        '0MRM030': 'ETOPS',
        '0MBO012': 'FH',
        '0MRM024': 'Cycle',
        9500159: 'Flight Details',
        9500160: 'Flight Creation',
        9500161: 'Flight Details',
        9500162: 'Flight date',
        material_type: 'Material type',
        due_date: 'Due Date',
        '1MRM097': 'Flight type',
        '1MRM026': 'A/B departure',
        '1MRM014': 'A/B arrival',
        '1MRM027': 'B/B departure',
        '1MRM015': 'B/B arrival',
        '0MRM082': 'Delay',
        '0MRM019': 'Code',
        7000027: 'Duration',
        7009267: 'Cancelled flight',
        7002855: 'Flight activities',
        7000645: 'To&Go',
        '1MRM018': 'Fuel',
        7000199: 'Qty',
        '1MRM069': 'Sheet No',
        9510061: 'Please refer to an Administrator for configuring fuel details!',
        9500163: 'Engines supplements',
        9300003: 'Comments',
        9300107: 'Fluid',
        9500171: 'Supplements',
        7002298: 'Engine',
        '0MRM010': 'APU',
        '0MRM025': 'Departure',
        '1MRM013': 'Arrival',
        9500164: 'You do not have enough permissions to create new data.',
        9500165: 'You do not have enough permissions to update this piece of data.',
        9500166: 'Loading in progress...',
        9500172: 'Last TL No',
        9500173: 'The document which you are trying to reach does not exist!',
        9160327: 'Total fuel on departure',
        9160330: 'Total fuel on arrival',
        9160331: 'Total fuel next flight',
        9510053: 'Incident/damage flight - Ground faults',
        7000101: 'Creation',
        9500182: 'Signature',
        9500183: 'Partial validation',
        9500184: 'Final validation',
        7009204: 'Creation successfully performed',
        9500189: 'Required resources',
        '1CMG001': 'Store',
        7000973: 'Store provisioning',
        '7000270': 'Manufacturer',
        7000248: 'Description',
        7001180: 'Stock',
        9500190: 'Provisioning center stock',
        '1P00425': 'RQ in progress',
        9500191: 'RQ status',
        9500192: 'Progress status',
        '1M00012': 'Performance location',
        9300198: 'Tool used',
        '1MOE030': 'Deadline',
        8000113: 'Manhours',
        9100287: 'Performer',
        '1M00128': 'Linked documents',
        '1P00005': 'Protocol',
        '1LEX050': 'Revision',
        '0MRM050': 'Item',
        9500193: 'Others',
        9510062: 'Filename',
        7009087: 'Installations',
        7009088: 'Removals',
        '0MBO018': 'Installation',
        '0MBO009': 'Removal',
        '0MOE063': 'OF No',
        7000956: 'Product type',
        9510068: 'Report',
        9510069: 'Hours scanning has been taken into account',
        '1MOE078': 'Personnel',
        '1MOE080': 'Procedure',
        9510083: 'Work with stocks',
        7000876: 'Cny / Sto',
        9510084: 'Blacklist Status',
        7001147: 'Inter',
        7009181: 'Stored alternates',
        7000341: 'From date',
        9510096: 'Start time',
        '1LMD002': 'To date',
        9510097: 'End time',
        '1CEF000': 'Effectivity',
        9510098: 'Type of linked document',
        '1C00018': 'Document type',
        7002402: 'Entry of fuel',
        7002623: 'Duration',
        '1C00016': 'Task code',
        7000334: 'Control',
        invalid_format: 'Please respect the requested format.',
        error_server: 'Server error!',
        error_spaces_not_allowed: 'Spaces are not allowed!',
        stepper_crm_step_0: 'Basic information',
        stepper_crm_step_1: 'Supplements',
        stepper_crm_step_2: 'Validation',
        message_access_after_creation_crm: 'You will be able to manage fuels items once the Techlog has been created!',
        placeholder_field_integer: 'Integer',
        placeholder_field_decimal: 'Decimal',
        placeholder_techlogs_avimmatr: 'Immatriculation',
        placeholder_techlogs_flight_date: 'dd/mm/yyyy',
        placeholder_techlogs_flight_number: 'Number',
        placeholder_techlogs_flight_type: 'Type',
        placeholder_techlogs_flight_airport: 'Airport',
        placeholder_techlogs_duration_heures_minutes: 'HH:mm',
        placeholder_techlogs_duration_heures_centiemes: 'H,cc',
        placeholder_techlogs_delay_code: 'Code',
        placeholder_techlogs_delay_label: 'Delay',
        placeholder_techlogs_delay_duration: 'minutes',
        placeholder_techlogs_activity_cycles: 'Cycles',
        placeholder_techlogs_activity_togo: 'To&Go',
        placeholder_techlogs_activity_atypique: 'Non-standard',
        placeholder_techlogs_engine: 'Engine',
        placeholder_techlogs_engine_apu: 'APU',
        placeholder_techlogs_hydro: 'Fluid',
        placeholder_techlogs_oil_type: 'Type',
        placeholder_techlogs_oil_qty: 'L, Pd',
        placeholder_techlogs_oil_number: 'Number',
        placeholder_techlogs_oil_qty_total: 'KG',
        placeholder_techlogs_comments: 'Additional comments',
      },
    },
    fr: {
      translation: {
        7000419: 'Oui',
        7000414: 'Non',
        aircraft: 'Aéronefs',
        pageWelcomeTitle: 'Accueil',
        light: 'Clair',
        dark: 'Sombre',
        entries_per_page: 'Entrées par page',
        sso_connect: 'Connection via SSO...',
        sso_login_fail: 'La connexion SSO a échoué. Veuillez vous connecter manuellement!',
        saveUserPreferences: 'Enregistrer préférences',
        updateSuccessful: 'La modification a été réalisée avec succès',
        '3C00002': 'Suppression effectuée',
        sessionExpired: 'Session expirée!',
        SSO_LOGIN_FAIL: 'La connexion par SSO (Single Sign-On) a échoué!',
        modal_messages_no_message: 'Pas de message à afficher!',
        modal_search_pn: 'Recherche PN',
        modal_search_sn: 'Recherche équipement',
        modal_search_staff: 'Recherche exécutant',
        modal_search_qualification: 'Recherche qualification',
        pagination_first: 'première',
        pagination_previous: 'précédente',
        expand_all: 'Tout déplier',
        collapse_all: 'Tout replier',
        pagination_next: 'suivante',
        pagination_last: 'dernière',
        7000014: 'En cours',
        7001655: 'Rechercher',
        7000398: 'Modifier',
        execute: 'Executer',
        work_completed: 'Travail effectué',
        work_not_completed: 'Travail non réalisé',
        modal_required_tools: 'Copier les ressources nécessaires',
        copy_tools: 'Copier {{pn}}',
        7003804: 'Code Non réalisation',
        7003805: 'Motif de Non réalisation',
        tracking: 'Suivi',
        input_compulsory_fields_missing: 'Vous devez renseigner toutes les données obligatoires avant de poursuivre.',
        input_fields_in_error: 'Certaines données saisies sont incomplètes ou erronnées.',
        disable_resource_copy:
          'Vous ne pouvez pas copier cette ressource car elle est déjà présente dans les ressources utilisées.',
        copy_used_resources: 'Copier les ressources nécessaires',
        required_sn_field: 'Le champ SN est obligatoire',
        labor_added: "Une entrée de main d'oeuvre sera ajoutée",
        OLD8034: 'Cette zone doit être renseignée',
        7000318: 'Ajouter',
        9500050: 'Tableau de Flotte',
        9500006: 'FR',
        9500007: 'EN',
        9500008: 'Afficher le profil',
        8000395: 'Déconnexion',
        8000144: 'Paramètres',
        8000569: 'Annuler',
        8000202: 'Valider',
        9500174: 'Soumettre',
        9510089: 'Etes-vous sûr(e) de vouloir supprimer définitivement cet élément?',
        9510090: 'Etes-vous sûr(e) de vouloir supprimer définitivement tous les éléments sélectionnés?',
        7003518: 'Badgeage des heures',
        'GEN0090': 'Les modifications en cours seront perdues, voulez-vous vraiment quitter cet écran ?',
        '3C00007': 'Les modifications en cours seront perdues, voulez-vous vraiment quitter le mode édition ?',
        7000483: 'Utilisateur',
        7000244: 'Mot de passe',
        9510043: 'Jeton',
        9510046: "L'authentification MFA a échoué",
        9510047: "Un problème d'authentification est survenu. Veuillez rafraîchir la page!",
        9480012: 'Mot de passe oublié',
        9500010: 'Ajouter des widgets',
        7001712: 'Planning',
        7000155: 'Immatriculation',
        9500011: 'Avancement global en H/H et items',
        workpackage_stats: 'Statistiques des items et H/H',
        9500012: 'Avancement par type de tâche',
        workpackage_task_detail: 'Détails par type de tâche',
        9500013: 'Augmenter la largeur',
        9500014: 'Diminuer la largueur',
        9500015: 'Augmenter la hauteur',
        9500016: 'Diminuer la hauteur',
        9500017: 'Charge par type de tâche',
        9500018: 'Résumé de la visite',
        9500019: 'Liste des tâches sélectionnées',
        9500020: 'Description OE',
        7000993: 'Légende',
        9500021: 'Réalisés',
        9500022: 'A réaliser',
        9500023: 'Heures homme',
        9500024: 'Items',
        9500025: 'N° OE',
        9500026: 'Statut',
        9500027: 'Code MEL',
        '1MOE048': 'Item de MEL',
        9500028: 'Date ouverture',
        9500029: 'Date échéance',
        9500030: 'Travail demandé ou anomalies',
        9500031: 'A/C',
        9500032: 'Escale',
        9500033: 'Dernier CRM',
        9500034: 'Date',
        7000374: 'Heure',
        9500035: 'Situation',
        9500036: 'Configuration',
        9500037: 'HIL',
        9500038: 'PPPR',
        9500039: 'OE',
        9500040: 'BDV ouvert',
        9500041: 'Type de tâche',
        9500042: 'Référence',
        9500043: 'Statut',
        9500044: 'Type de suivi',
        9500045: 'Potentiel restant',
        9500046: 'Type de maintenance',
        9500047: 'PN',
        9500048: 'SN',
        9500049: 'Travail demandé ou anomalies',
        9500051: 'Liste des aéronefs à présenter',
        9500052: 'Report',
        9500053: 'Plus Petit Potentiel Restant (PPPR)',
        9500054: "Ordre d'Exécution (OE)",
        9500055: 'Pas de données à afficher.',
        '0LMA106': 'Total',
        9500077: 'Page',
        9500078: 'Ce widget ne peut pas être retiré car il fait partie des widgets minimaux de la page!',
        9500079: 'Ce widget est optionnel et peut être retiré en cliquant sur ce bouton.',
        9500081: "Libellé de l'Item",
        '1M00023': 'Ss-Type',
        9500092: 'Situation BDV',
        9500095: 'Tâches sans H/h',
        9500096: 'Reportés',
        9500097: 'Ops',
        9500119: 'Ops CHK',
        9500098: 'Ops OOP',
        9500099: 'OE',
        9500100: 'OE (TL)',
        9500101: 'OE (MC)',
        9500102: 'OE (DOC)',
        9500103: 'OE (KX)',
        9500104: 'OE (MIS)',
        9500105: 'Trvx Supp.',
        9500106: 'Aucune donnée existante.',
        9500107: "Avancement chantier (du début jusqu'à aujourd'hui)",
        9500108: 'Parking',
        7003777: 'Hangar',
        9500109: 'Total',
        9500110: 'OP (Tous types)',
        7003008: 'Tâches',
        9500117: 'A exécuter',
        9400199: 'Exécuté',
        9500111: 'Reporté',
        9100848: 'Avec TS',
        9500118: 'Nbre de TS',
        9500112: 'Travaux supplémentaires',
        7000841: 'It',
        9500115: 'Type Items',
        '1LEX071': 'Document',
        9200107: 'RE/TS',
        '0P00003': 'Titre',
        '0EKS004': 'ATA',
        7000494: 'Zone',
        '1MOE023': 'Date exécution',
        '1P00399': 'Report/TS',
        '0MRM071': 'N° OE',
        9500116:
          "Ce widget ne peut pas être retiré car il dépend d'un autre widget. Pour le retirer, veuillez retirer le widget dont il dépend!",
        9420008: 'Validation Commande',
        '1P00012': 'Type',
        9500121: 'N° commande',
        7000480: 'Urgence',
        7000588: 'Date limite',
        7000892: 'Responsable',
        7001518: 'Valideur',
        7001950: 'Fournisseur',
        7001202: 'Total HT',
        9500122: 'Niveau actuel',
        9500123: 'Niveau requis',
        9500124: 'Commande à valider',
        9500132: "Vous êtes à présent connecté(e) à l'application.",
        9500133: "Vous n'êtes à présent plus connecté(e) à l'application.",
        9500134: 'Effacer tous les messages',
        9220626: 'Refuser',
        9500136: 'Signer',
        9500137: 'Finaliser',
        9500138: "Vous n'avez pas les droits suffisants pour accéder à cette fonctionnalité.",
        9500139: 'Choisissez le prochain valideur',
        9500144: "Ordre d'exécution",
        7001905: 'N°',
        9500143: 'Chantier lié',
        9400064: "Date d'ouverture",
        '1MOE031': 'Emetteur',
        8000442: 'Poste de travail',
        '1P08215': 'Phase',
        7000914: 'Qualification',
        '2MOE097': 'Travail demandé',
        '2MOE098': 'Travail effectué',
        9100439: 'par',
        9501005: 'Vous n’avez pas les permissions requises pour visualiser cette commande.',
        9500148: 'Vous devez configurer les prochains valideurs dans AMASIS.',
        9500149: 'La commande a déjà été validée avec le même niveau de validation.',
        9500150:
          'Vous ne pouvez pas valider cette commande car le niveau de validation requis est supérieur à votre niveau de validation.',
        9500145: 'Refus commande {0}',
        9500151: 'Saisissez une raison',
        9500152: 'Validation commande {0}',
        9500153: 'Cette commande nécessite une validation complémentaire.',
        9500155: 'Sélectionnez le valideur suivant',
        9500156: 'Seule la consultation de cette commande est possible!',
        9500157: 'Affichage avec tolérances',
        7001825: 'Liste des CRM',
        '0MOE065': 'N° CRM',
        7002927: 'N° de vol',
        9420175: 'Aéroport de départ',
        9420176: "Aéroport d'arrivée",
        9500158: 'Durée de vol (AB)',
        9500185: 'Durée de vol (BB)',
        '0MRM030': 'ETOPS',
        '0MBO012': 'FH',
        '0MRM024': 'Cycle',
        9500159: 'Détails du vol',
        9500160: "Saisie d'un vol",
        9500161: 'Données du vol',
        9500162: 'Date du vol',
        material_type: 'Type de matériel',
        due_date: 'Echéance',
        '1MRM097': 'Type de vol',
        '1MRM026': 'Départ AB',
        '1MRM014': 'Arrivée AB',
        '1MRM027': 'Départ BB',
        '1MRM015': 'Arrivée BB',
        '0MRM082': 'Retard',
        '0MRM019': 'Code',
        7000027: 'Temps',
        7009267: 'Vol annulé',
        7002855: 'Activités du vol',
        7000645: 'To&Go',
        '1MRM018': 'Carburant',
        7000199: 'Qté',
        '1MRM069': 'N° bon',
        9510061: "Veuillez vous rapprochez d'un Administrateur pour configurer les carburants!",
        9500163: 'Compléments Moteurs',
        9300003: 'Commentaires',
        9300107: 'Fluide',
        9500171: 'Compléments',
        7002298: 'Moteur',
        '0MRM010': 'APU',
        '0MRM025': 'Départ',
        '1MRM013': 'Arrivée',
        9500164: 'Vous n’avez pas les permissions requises pour créer une nouvelle donnée.',
        9500165: 'Vous n’avez pas les permissions requises pour mettre à jour cette donnée.',
        9500166: 'En cours de chargement...',
        9500172: 'N° Dernier CRM',
        9500173: "Le document auquel vous essayez d'accéder n'existe pas!",
        9160327: 'Total carburant départ',
        9160330: "Total carburant à l'arrivée",
        9160331: 'Total carburant prochain vol',
        9510053: 'Incident/avarie vol - Défauts sol',
        7000101: 'Création',
        9500182: 'Signature',
        9500183: 'Validation intermédiaire',
        9500184: 'Validation finale',
        7009204: 'La création a été effectuée avec succès',
        9500189: 'Ressources nécessaires',
        '1CMG001': 'Magasin',
        7000973: 'Magasin Réapp',
        '7000270': 'Fabricant',
        7000248: 'Désignation',
        7001180: 'Stock',
        9500190: 'Stock Magasin Appro.',
        '1P00425': 'DA en cours',
        9500191: 'Statut DA',
        9500192: 'Statut avancement',
        '1M00012': "Lieu d'exécution",
        9300198: 'Outillage utilisé',
        '1MOE030': 'Echéance',
        8000113: "Main d'oeuvre",
        9100287: 'Exécutant',
        '1M00128': 'Documents liés',
        '1P00005': 'Protocole',
        '1LEX050': 'Révision',
        '0MRM050': 'Item',
        9500193: 'Autres',
        9510062: 'Nom du fichier',
        7009087: 'Poses',
        7009088: 'Déposes',
        '0MBO018': 'Pose',
        '0MBO009': 'Dépose',
        '0MOE063': 'N° BO',
        7000956: 'Type produit',
        9510068: 'Constat',
        9510069: 'Le badgeage a bien été pris en compte',
        '1MOE078': 'Personnel',
        '1MOE080': 'Procédure',
        9510083: 'Consultation des stocks',
        7000876: 'Soc / Mag',
        9510084: 'Statut Blacklist',
        7001147: 'Inter',
        7009181: 'Interchangeables en stock',
        7000341: 'Date début',
        9510096: 'Heure début',
        '1LMD002': 'Date fin',
        9510097: 'Heure fin',
        '1CEF000': 'Applicabilité',
        9510098: 'Type de document lié',
        '1C00018': 'Type de document',
        7002402: 'Saisie du carburant',
        7002623: 'Durée',
        '1C00016': 'Code tâche',
        7000334: 'Contrôle',

        error_server: 'Erreur serveur!',
        error_spaces_not_allowed: 'Les espaces ne sont pas autorisés!',
        message_access_after_creation_crm: 'Vous pourrez gérer cette section après la création du CRM.',
        stepper_crm_step_0: 'Informations standard',
        stepper_crm_step_1: 'Compléments',
        stepper_crm_step_2: 'Validation',
        placeholder_field_integer: 'Entier',
        placeholder_field_decimal: 'Décimal',
        placeholder_techlogs_avimmatr: 'Immatriculation',
        placeholder_techlogs_flight_date: 'jj/mm/aaaa',
        placeholder_techlogs_flight_number: 'Numéro',
        placeholder_techlogs_flight_type_code: 'Type',
        placeholder_techlogs_flight_type_label: 'Type',
        placeholder_techlogs_flight_airport: 'Aéroport',
        placeholder_techlogs_duration_heures_minutes: 'HH:mm',
        placeholder_techlogs_duration_heures_centiemes: 'H,cc',
        placeholder_techlogs_delay_code: 'Retard',
        placeholder_techlogs_delay_label: 'Retard',
        placeholder_techlogs_delay_duration: 'minutes',
        placeholder_techlogs_activity_cycles: 'Cycles',
        placeholder_techlogs_activity_togo: 'To&Go',
        placeholder_techlogs_activity_atypique: 'Atypique',
        placeholder_techlogs_engine: 'Moteur',
        placeholder_techlogs_engine_apu: 'APU',
        placeholder_techlogs_hydro: 'Fluide',
        placeholder_techlogs_oil_type: 'Type',
        placeholder_techlogs_oil_qty: 'L, Pd',
        placeholder_techlogs_oil_number: 'Numéro',
        placeholder_techlogs_oil_qty_total: 'KG',
        placeholder_techlogs_comments: 'Commentaires complémentaires',
      },
    },
  },
  lng: 'fr',
  fallbackLng: 'en',
})

export default i18n
